export const styles = {
  modalOverlay: {
    position: 'fixed' as const,
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    zIndex: 1000,
    display: 'flex',
    justifyContent: 'flex-end' as const,
    alignItems: 'center' as const,
    flexDirection: 'column' as const,
  },
  content: {
    width: 'calc(100vw - 24px)', // 12px отступ с каждой стороны как в RN
    maxWidth: 'calc(100vw - 24px)',
    borderRadius: 16,
    overflow: 'hidden' as const,
    marginBottom: 50, // Отступ снизу как в RN
  },
  actionItem: {
    padding: 18,
    cursor: 'pointer' as const,
    transition: 'background-color 0.2s ease',
  },
  separator: {
    height: 0.5, // Как в RN borderWidth: 0.5
    marginHorizontal: 0, // Без отступов как в RN
  },
} as const
